
(function () {
  if (window.__veeryWishlistDrawerReady) return;
  window.__veeryWishlistDrawerReady = true;

  var overlay = document.querySelector('[data-vwl-overlay]');
  var drawer = document.querySelector('[data-vwl-drawer]');
  var body = drawer ? drawer.querySelector('[data-vwl-body]') : null;
  var aviso = drawer ? drawer.querySelector('[data-vwl-aviso]') : null;
  var sugerencias = drawer ? drawer.querySelector('[data-vwl-sugerencias]') : null;
  var countText = drawer ? drawer.querySelector('[data-vwl-count-text]') : null;
  var countLabel = drawer ? drawer.querySelector('[data-vwl-count-label]') : null;
  if (!drawer || !body) return;

  var LBL_REMOVE = drawer.getAttribute('data-vwl-lbl-remove') || 'Remove';
  function lbl(nombre, reserva) { return drawer.getAttribute('data-vwl-' + nombre) || reserva; }

  var abierto = false;
  var focoPrevio = null;
  var inertes = [];

  function enfocables() {
    var sel = 'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])';
    var todos = drawer.querySelectorAll(sel);
    var visibles = [];
    for (var i = 0; i < todos.length; i++) {
      if (todos[i].closest('[aria-hidden="true"]') && todos[i].closest('[aria-hidden="true"]') !== drawer) continue;
      if (todos[i].offsetParent !== null || todos[i] === document.activeElement) visibles.push(todos[i]);
    }
    return visibles;
  }

  function atraparTab(e) {
    if (!abierto || e.key !== 'Tab') return;
    var f = enfocables();
    if (!f.length) { e.preventDefault(); return; }
    var idx = f.indexOf(document.activeElement);
    var dentro = drawer.contains(document.activeElement);
    if (e.shiftKey && idx <= 0) {
      e.preventDefault();
      f[f.length - 1].focus();
    } else if (!e.shiftKey && (!dentro || idx === f.length - 1)) {
      e.preventDefault();
      f[0].focus();
    }
  }

  function ponerInert() {
    if (inertes.length) return;
    inertes = [];
    var hijos = document.body.children;
    for (var i = 0; i < hijos.length; i++) {
      var el = hijos[i];
      if (el.contains(drawer) || el.tagName === 'SCRIPT' || el.hasAttribute('inert')) continue;
      el.setAttribute('inert', '');
      inertes.push(el);
    }
  }
  function quitarInert() {
    for (var i = 0; i < inertes.length; i++) inertes[i].removeAttribute('inert');
    inertes = [];
  }

  var lenisParado = null;
  function pararLenis() {
    var l = window.VeerySmooth && window.VeerySmooth.instance;
    if (lenisParado || !l || l.isStopped || typeof l.stop !== 'function') return;
    l.stop();
    lenisParado = l;
  }
  function soltarLenis() {
    var l = lenisParado;
    lenisParado = null;
    if (l && typeof l.start === 'function' && window.VeerySmooth && window.VeerySmooth.instance === l) l.start();
  }

  function enfocarTitulo() {
    var titulo = drawer.querySelector('.vwl__title');
    if (!titulo) return;
    if (!titulo.hasAttribute('tabindex')) titulo.setAttribute('tabindex', '-1');
    titulo.focus({ preventScroll: true });
  }

  function openDrawer() {
    render();
    if (!abierto) focoPrevio = document.activeElement;
    abierto = true;
    drawer.setAttribute('data-open', 'true');
    drawer.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.setAttribute('data-open', 'true');
    document.documentElement.style.overflow = 'hidden';
    pararLenis();
    ponerInert();
    enfocarTitulo();
    var intentos = 0;
    (function reintentar() {
      if (!abierto || drawer.contains(document.activeElement) || intentos++ > 5) return;
      setTimeout(function () { enfocarTitulo(); reintentar(); }, 100);
    })();
  }
  function closeDrawer() {
    limpiarDeshacer();
    var estabaAbierto = abierto;
    abierto = false;
    drawer.setAttribute('data-open', 'false');
    drawer.setAttribute('aria-hidden', 'true');
    if (overlay) overlay.setAttribute('data-open', 'false');
    document.documentElement.style.overflow = '';
    soltarLenis();
    quitarInert();
    if (!estabaAbierto) return;
    var destino = focoPrevio && document.contains(focoPrevio) ? focoPrevio : null;
    if (!destino) {
      var corazones = document.querySelectorAll('[data-vwl-open]');
      for (var i = 0; i < corazones.length; i++) {
        if (corazones[i].offsetParent !== null) { destino = corazones[i]; break; }
      }
    }
    focoPrevio = null;
    if (destino && typeof destino.focus === 'function') destino.focus({ preventScroll: true });
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest ? e.target.closest('[data-vwl-open]') : null;
    if (opener) { e.preventDefault(); openDrawer(); return; }
    var closer = e.target.closest ? e.target.closest('[data-vwl-close]') : null;
    if (closer) { closeDrawer(); }
  });
  if (overlay) overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && abierto) closeDrawer();
    atraparTab(e);
  });

  function formatMoney(cents) {
    return window.VeeryWishlist.formatMoney(cents);
  }
  function esc(str) {
    return window.VeeryWishlist.escapeHtml(str);
  }


  function cdn(url, w) {
    if (!url) return '';
    var u = url.indexOf('//') === 0 ? 'https:' + url : url;
    return u + (u.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }

  function antesDe(p) {
    var minimo = p.price_min || p.price;
    var vs = p.variants || [];
    for (var i = 0; i < vs.length; i++) {
      if (vs[i].price === minimo && vs[i].compare_at_price > vs[i].price) return vs[i].compare_at_price;
    }
    return 0;
  }

  function priceHtml(p) {
    var cifra = function (c) { return '<span class="vwl__cifra">' + formatMoney(c) + '</span>'; };
    var texto = cifra(p.price_min || p.price);
    if (p.price_varies) {
      var desde = lbl('lbl-desde', 'From __PRECIO__').split('__PRECIO__');
      texto = (desde[0] ? esc(desde[0]) : '') + texto + (desde[1] ? esc(desde[1]) : '');
    }
    if (antesDe(p)) return '<ins><span class="visually-hidden">' + esc(lbl('lbl-oferta', 'Sale price')) + '</span>' + texto + '</ins>';
    return '<span>' + texto + '</span>';
  }

  function rebajaHtml(p) {
    var antes = antesDe(p);
    if (!antes) return '';
    var pct = Math.floor((antes - (p.price_min || p.price)) * 100 / antes);
    return '<span class="vwl__rebaja-grupo">' +
      '<del class="vwl__tachado"><span class="visually-hidden">' + esc(lbl('lbl-habitual', 'Regular price')) + '</span>' + formatMoney(antes) + '</del>' +
      (pct > 0 ? '<span class="vwl__rebaja">' + esc(lbl('lbl-rebaja', '−__PCT__%').replace('__PCT__', pct)) + '</span>' : '') +
    '</span>';
  }

  var MARCOS = lbl('marcos', '').toLowerCase().split('‖').filter(Boolean);

  function comoHandle(v) {
    return String(v).toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  function esTalla(o) {
    return /^\s*\d+(?:[.,]\d+)?\s*[x×]\s*\d+/i.test(String(o.values[0]));
  }

  function esMarco(o) {
    return o.values.some(function (v) {
      var s = String(v).trim().toLowerCase();
      return MARCOS.indexOf(s) !== -1 || MARCOS.indexOf(comoHandle(s)) !== -1;
    });
  }

  function recuento(clave, n, reserva) {
    var plantilla = lbl('lbl-' + clave + (n === 1 ? '-1' : '-n'), reserva);
    return plantilla.split('__N__').join(String(n));
  }

  function resumenOpciones(p) {
    var opciones = (p.options || []).filter(function (o) { return o && o.values && o.values.length; });
    var talla = null;
    var marco = null;
    opciones.forEach(function (o) {
      if (!marco && esMarco(o)) marco = o;
      else if (!talla && esTalla(o)) talla = o;
    });
    if (!marco && talla && opciones.length === 2) marco = opciones[0] === talla ? opciones[1] : opciones[0];
    var partes = [];
    opciones.forEach(function (o) {
      var n = o.values.length;
      if (n < 2) return;
      if (o === talla) partes.push(recuento('tallas', n, '__N__ sizes'));
      else if (o === marco) partes.push(recuento('marcos', n, '__N__ finishes'));
      else partes.push(recuento('opciones', n, '__N__ options'));
    });
    return partes.join(' · ');
  }

  function accionPrincipal(p, url) {
    if (p.available === false) {
      return '<span class="vwl__agotado">' + esc(lbl('lbl-agotado', 'Sold out')) + '</span>';
    }
    var opciones = (p.options || []).filter(function (o) { return o.values && o.values.length > 1; });
    var tieneTalla = opciones.some(function (o) { return /^\s*\d+(?:[.,]\d+)?\s*[x×]\s*\d+/i.test(o.values[0]); });
    var tx = (drawer && drawer.dataset) || {};
    var texto = tieneTalla ? (tx.vwlLblElegirTalla || 'Choose size') : (opciones.length ? (tx.vwlLblElegirOpciones || 'Choose options') : (tx.vwlLblVer || 'View print'));
    return '<a class="vwl__elegir" href="' + url + '">' + texto + '</a>';
  }

  function emptyMarkup() {
    return (
      '<div class="vwl__empty">' +
        '<span class="vwl__empty-icon">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
            '<path d="M12 20s-7-4.4-7-10a4 4 0 0 1 7-2.6A4 4 0 0 1 19 10c0 5.6-7 10-7 10z"/>' +
          '</svg>' +
        '</span>' +
        '<p class="vwl__empty-title">' + esc(lbl('lbl-vacio-titulo', 'No favourites yet.')) + '</p>' +
        '<p class="vwl__empty-text">' + esc(lbl('lbl-vacio-texto', 'Tap the heart on any print to keep it here while you decide. No account needed.')) + '</p>' +
        '<a class="vwl__empty-cta" href="' + esc(lbl('url-vacio', '/collections/all')) + '">' + esc(lbl('lbl-vacio-enlace', 'Explore prints')) + '</a>' +
        (sugerencias ? sugerencias.innerHTML : '') +
      '</div>'
    );
  }

  var deshacer = null;
  function limpiarDeshacer() {
    if (deshacer && deshacer.timer) clearTimeout(deshacer.timer);
    deshacer = null;
  }
  function undoMarkup() {
    var quitada = lbl('lbl-quitada', '__obra__ removed').split('__obra__');
    return (
      '<div class="vwl__undo" role="status">' +
        '<span class="vwl__undo-text">' + esc(quitada[0] || '') + '<span class="vwl__undo-obra">' + esc(deshacer.titulo) + '</span>' + esc(quitada[1] || '') + '</span>' +
        '<button type="button" class="vwl__undo-btn" data-vwl-undo>' + esc(lbl('lbl-deshacer', 'Undo')) + '</button>' +
      '</div>'
    );
  }

  function urlProducto(handle) {
    var raizIdioma = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return raizIdioma + 'products/' + handle;
  }

  function imagenDelProducto(p) {
    return (p && (p.featured_image || (p.images && p.images[0]))) || '';
  }

  function claveImagen(u) {
    var partes = String(u).split('?');
    var archivo = partes[0].split('/').pop();
    var version = (partes[1] || '').match(/(?:^|&)v=([^&]+)/);
    return archivo + '|' + (version ? version[1] : '');
  }

  function mismaImagen(a, b) {
    return !!a && !!b && claveImagen(a) === claveImagen(b);
  }

  function anchoMini() {
    var W = window.VeeryWishlist;
    return (W && typeof W.anchoMiniatura === 'function') ? W.anchoMiniatura() : 200;
  }

  function thumbHtml(handle, urlFinal) {
    return (
      '<a class="vwl__thumb" href="' + urlProducto(handle) + '" tabindex="-1" aria-hidden="true">' +
        (urlFinal ? '<img src="' + urlFinal + '" alt="" decoding="async" fetchpriority="high">' : '') +
      '</a>'
    );
  }

  function infoHtml(handle, p) {
    var url = urlProducto(handle);
    var detalle = resumenOpciones(p);
    return (
      '<div class="vwl__info">' +
        '<div class="vwl__fila">' +
          '<h3 class="vwl__nombre"><a href="' + url + '">' + esc(p.title) + '</a></h3>' +
          '<p class="vwl__precio">' + priceHtml(p) + '</p>' +
        '</div>' +
        (rebajaHtml(p) ? '<div class="vwl__linea-rebaja">' + rebajaHtml(p) + '</div>' : '') +
        (detalle ? '<p class="vwl__detalle">' + esc(detalle) + '</p>' : '') +
        '<div class="vwl__acciones">' +
          accionPrincipal(p, url) +
          '<button type="button" class="vwl__quitar" data-vwl-remove="' + esc(handle) + '" aria-label="' + esc(LBL_REMOVE + ' ' + p.title) + '">' + esc(LBL_REMOVE) + '</button>' +
        '</div>' +
      '</div>'
    );
  }

  function falloHtml(handle) {
    return (
      '<div class="vwl__info">' +
        '<p class="vwl__detalle">' + esc(lbl('lbl-fallo', 'We couldn’t load this print.')) + '</p>' +
        '<div class="vwl__acciones">' +
          '<button type="button" class="vwl__quitar" data-vwl-reintentar>' + esc(lbl('lbl-reintentar', 'Try again')) + '</button>' +
          '<button type="button" class="vwl__quitar" data-vwl-remove="' + esc(handle) + '">' + esc(LBL_REMOVE) + '</button>' +
        '</div>' +
      '</div>'
    );
  }

  function cardHtml(handle, p) {
    var img = imagenDelProducto(p);
    return thumbHtml(handle, img ? cdn(img, anchoMini()) : '') + infoHtml(handle, p);
  }

  function render(forzar) {
    var W = window.VeeryWishlist;
    if (!W) return;
    var handles = W.getAll();

    if (countText) countText.textContent = handles.length;
    var lbl = (drawer && drawer.dataset) || {};
    if (countLabel) countLabel.textContent = handles.length === 1 ? (lbl.vwlLblLamina || 'print') : (lbl.vwlLblLaminas || 'prints');

    var franja = deshacer ? undoMarkup() : '';
    if (aviso) aviso.innerHTML = franja;

    if (handles.length === 0) {
      drawer.setAttribute('data-empty', 'true');
      body.innerHTML = (aviso ? '' : franja) + emptyMarkup();
      return;
    }
    drawer.setAttribute('data-empty', 'false');

    body.innerHTML = aviso ? '' : franja;
    for (var i = 0; i < handles.length; i++) {
      (function (handle) {
        var recordada = (typeof W.imagenDe === 'function' && W.imagenDe(handle)) || '';
        var row = document.createElement('div');
        row.className = 'vwl__item is-loading';
        row.setAttribute('data-vwl-row', handle);
        var listaYa = recordada && typeof W.urlMiniatura === 'function' ? W.urlMiniatura(handle) : '';
        row.innerHTML = (listaYa ? thumbHtml(handle, listaYa) : '<div class="vwl__thumb"></div>') + '<div class="vwl__info"></div>';
        body.appendChild(row);

        W.fetchProduct(handle, forzar === true).then(function (product) {
          row.classList.remove('is-loading');
          row.setAttribute('data-vwl-title', product.title || '');
          var real = imagenDelProducto(product);
          var info = row.querySelector('.vwl__info');
          if (recordada && mismaImagen(recordada, real) && info) {
            info.outerHTML = infoHtml(handle, product);
          } else {
            row.innerHTML = cardHtml(handle, product);
            if (typeof W.recordarImagen === 'function') W.recordarImagen(handle, real);
          }
        }).catch(function (fallo) {
          if (fallo && fallo.status === 404) {
            if (row.parentNode) row.parentNode.removeChild(row);
            W.remove(handle);
            return;
          }
          row.classList.remove('is-loading');
          row.setAttribute('data-vwl-title', handle);
          var info = row.querySelector('.vwl__info');
          if (info) info.outerHTML = falloHtml(handle);
        });
      })(handles[i]);
    }
  }

  drawer.addEventListener('click', function (e) {
    var W = window.VeeryWishlist;
    if (!W || !e.target.closest) return;

    if (e.target.closest('[data-vwl-reintentar]')) {
      render(true);
      enfocarTitulo();
      return;
    }

    var undo = e.target.closest('[data-vwl-undo]');
    if (undo) {
      var volver = deshacer && deshacer.handle;
      var sitio = deshacer ? deshacer.indice : -1;
      limpiarDeshacer();
      if (!volver) return;
      if (typeof W.insertAt === 'function') W.insertAt(volver, sitio);
      else W.add(volver);
      return;
    }

    var btn = e.target.closest('[data-vwl-remove]');
    if (!btn) return;
    var handle = btn.getAttribute('data-vwl-remove');
    var fila = btn.closest('[data-vwl-row]');
    limpiarDeshacer();
    deshacer = {
      handle: handle,
      indice: W.getAll().indexOf(handle),
      titulo: (fila && fila.getAttribute('data-vwl-title')) || 'Print',
      timer: setTimeout(function () {
        deshacer = null;
        var f = (aviso || body).querySelector('.vwl__undo');
        if (f && f.parentNode) f.parentNode.removeChild(f);
      }, 6000)
    };
    W.remove(handle);
  });

  document.addEventListener('veery:wishlist:change', function () {
    if (drawer.getAttribute('data-open') === 'true') render();
  });
})();
